export enum DashboardPermissionEnum {
    PatientDashboard = "Patient Dashboard",
    OrdersDashboard = "Orders Dashboard",
    ScheduleDashboard = "Schedule Dashboard",
    BillingDashboard = "Billing Dashboard",
    AdminDashboard = "Admin Dashboard"
}
